"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextSunsetSunriseTimeLocal = exports.getDSTOffsetM = exports.mapSchedules = exports.createScheduleFromAPI = exports.calculateSunsetSunriseTime = exports.convertScheduleFrameToAPIScheduleFrame = exports.getCloudFriendlyTime = exports.convertOcelotDaysToIndexDays = exports.convertIndexDaysToOcelotDays = exports.getTimeFromCloudSched = exports.constructSwitchDeviceSchedule = void 0;
const lodash_1 = __importDefault(require("lodash"));
const log_1 = require("log");
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const IndexApiProfileRequestTypes_1 = require("../../Types/IndexApiProfileRequestTypes");
const TypeUtils_1 = require("./TypeUtils");
const constructSwitchDeviceSchedule = (device, schedId, frame) => {
    const switchSchedules = Object.entries(device.model.schedules)
        .map(([key, switchFrame]) => (Object.assign(Object.assign({}, switchFrame), { slot: Number(key) })));
    const schedOnDevice = switchSchedules.find((v) => v.frame === frame && v.id === schedId);
    if (schedOnDevice === undefined) {
        throw new Error(`Couldn't find ${schedId} on any switches`);
    }
    return {
        meshId: device.mesh.uniqueId,
        slot: schedOnDevice.slot,
        lytebyte: schedOnDevice.lytebyte,
    };
};
exports.constructSwitchDeviceSchedule = constructSwitchDeviceSchedule;
const constructSchedFrameDeviceInfo = (sched, frame, device) => {
    if ((0, TypeUtils_1.isIndexAPIDeviceSwitch)(device) || (0, TypeUtils_1.isIndexAPIDevicePlug)(device)) {
        return (0, exports.constructSwitchDeviceSchedule)(device, sched.id, frame);
    }
    throw new Error(`Unrecognized device type for schedule: ${device.type}`);
};
const getTimeFromCloudSched = (time) => {
    if (time.length === 0) {
        throw new Error("Time string cannot be 0 length");
    }
    const splitTime = time.split(":");
    if (splitTime.length < 2) {
        return new Date();
    }
    const date = new Date();
    date.setHours(parseInt(splitTime[0], 10), parseInt(splitTime[1], 10), 0);
    return date;
};
exports.getTimeFromCloudSched = getTimeFromCloudSched;
const constructScheduleFrame = (sched, frame, device) => {
    const apiFrame = frame === "start" ? sched.start : sched.end;
    if (!apiFrame || apiFrame.type === null) {
        return undefined;
    }
    if ((0, TypeUtils_1.isIndexAPIScheduleTimeFrame)(apiFrame)) {
        return Object.assign(Object.assign({}, apiFrame), { trigger: { time: (0, exports.getTimeFromCloudSched)(apiFrame.data.time) }, update: Object.assign({}, apiFrame.update.state), storageData: constructSchedFrameDeviceInfo(sched, frame, device) });
    }
    if ((0, TypeUtils_1.isIndexAPIScheduleEventFrame)(apiFrame)) {
        return Object.assign(Object.assign({}, apiFrame), { update: Object.assign({}, apiFrame.update.state), trigger: Object.assign({}, apiFrame.data), storageData: constructSchedFrameDeviceInfo(sched, frame, device) });
    }
    throw new Error(`Unsupported schedule frame: ${JSON.stringify(apiFrame)}`);
};
const convertIndexDaysToOcelotDays = (schedule) => {
    const indexAPIDays = ["NOT_A_DAY", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const { days } = schedule;
    const ocelotDays = [];
    for (const day of days) {
        ocelotDays.push(indexAPIDays.indexOf(day));
    }
    ocelotDays.sort();
    return ocelotDays;
};
exports.convertIndexDaysToOcelotDays = convertIndexDaysToOcelotDays;
const convertOcelotDaysToIndexDays = (days) => {
    const indexedScheduleDays = Object.values(IndexApiProfileRequestTypes_1.IndexAPIScheduleDays).filter((i) => Number.isNaN(Number(i)));
    return lodash_1.default.compact((days === null || days === void 0 ? void 0 : days.map((d) => indexedScheduleDays.slice(d - 1, d).shift())) || []);
};
exports.convertOcelotDaysToIndexDays = convertOcelotDaysToIndexDays;
const getCloudFriendlyTime = (time) => {
    if (time === undefined) {
        return "00:00:00";
    }
    const maxPad = 2;
    const hours = String(time.getHours()).padStart(maxPad, "0");
    const minutes = String(time.getMinutes()).padStart(maxPad, "0");
    return `${hours}:${minutes}:00`;
};
exports.getCloudFriendlyTime = getCloudFriendlyTime;
const convertScheduleFrameToAPIScheduleFrame = (target, frame) => {
    if ((0, TypeUtils_1.isScheduleTimeFrame)(frame)) {
        const time = (0, exports.getCloudFriendlyTime)(frame.trigger.time);
        return {
            type: IndexApiProfileRequestTypes_1.ScheduleFrameType.TIME,
            data: { time },
            update: {
                target,
                state: Object.assign({}, frame.update),
            },
        };
    }
    if ((0, TypeUtils_1.isScheduleEventFrame)(frame)) {
        return {
            type: IndexApiProfileRequestTypes_1.ScheduleFrameType.EVENT,
            data: Object.assign({}, frame.trigger),
            update: {
                target,
                state: Object.assign({}, frame.update),
            },
        };
    }
    throw new Error("Can't get time for a schedule that isn't triggered by time");
};
exports.convertScheduleFrameToAPIScheduleFrame = convertScheduleFrameToAPIScheduleFrame;
const SUNRISE_SUNSET_ZENITH = {
    official: 90.0 + (50.0 / 60.0),
    civil: 96.0,
    nautical: 102.0,
    astronomical: 108,
};
const UTCDate = (date) => ({
    day: date.getUTCDate(),
    month: date.getUTCMonth() + 1,
    year: date.getUTCFullYear(),
});
const dayOfYear = (today) => {
    const { floor } = Math;
    const { day, month, year } = UTCDate(today);
    const N1 = floor((275 * month) / 9);
    const N2 = floor((month + 9) / 12);
    const N3 = (1 + floor((year - 4 * floor(year / 4) + 2) / 3));
    return N1 - (N2 * N3) + day - 30;
};
const adjust = (n, bounds) => {
    const { lower, upper } = bounds;
    let value = n;
    while (value < lower) {
        value += upper;
    }
    while (value >= upper) {
        value -= upper;
    }
    return value;
};
const DEG = (r) => (r * 180) / Math.PI;
const RAD = (d) => (d * Math.PI) / 180;
const calculateSunsetSunriseTime = ({ date, type, location }) => {
    const { acos, asin, atan, cos, floor, sin, tan, } = Math;
    const { latitude, longitude } = location;
    const zenith = SUNRISE_SUNSET_ZENITH.official;
    const dayOfYearSum = dayOfYear(date);
    log_1.Log.debug(`[IndexUtils/Schedules] day of the year: ${dayOfYearSum}`);
    const lngHour = longitude / 15.0;
    let approximateTime;
    if (type === IndexApiProfileRequestTypes_1.ScheduleFrameEvent.SUNRISE) {
        approximateTime = dayOfYearSum + ((6.0 - lngHour) / 24.0);
    }
    else {
        approximateTime = dayOfYearSum + ((18.0 - lngHour) / 24.0);
    }
    const meanAnomoly = (0.9856 * approximateTime) - 3.289;
    let trueLong = meanAnomoly + (1.916 * sin(RAD(meanAnomoly)) + (0.020 * sin(2 * RAD(meanAnomoly))) + 282.634);
    trueLong = adjust(trueLong, {
        lower: 0.0,
        upper: 360.0,
    });
    let rightAscension = DEG(atan(0.91764 * tan(RAD(trueLong))));
    rightAscension = adjust(rightAscension, {
        lower: 0.0,
        upper: 360.0,
    });
    const lQuad = floor(trueLong / 90.0) * 90.0;
    const rAscensionQuad = floor(rightAscension / 90.0) * 90.0;
    rightAscension += lQuad - rAscensionQuad;
    rightAscension /= 15.0;
    const sinDeclination = 0.39782 * sin(RAD(trueLong));
    const cosDeclination = cos(asin(sinDeclination));
    const cosH = (cos(RAD(zenith)) - (sinDeclination * sin(RAD(latitude)))) / (cosDeclination * cos(RAD(latitude)));
    if (cosH > 1) {
        return undefined;
    }
    if (cosH < -1) {
        return undefined;
    }
    let hours = -1;
    if (type === IndexApiProfileRequestTypes_1.ScheduleFrameEvent.SUNRISE) {
        hours = 360.0 - DEG(acos(cosH));
    }
    else {
        hours = DEG(acos(cosH));
    }
    hours /= 15.0;
    const localMeanTime = hours + rightAscension - (0.06571 * approximateTime) - 6.622;
    let ut = localMeanTime - lngHour;
    ut = adjust(ut, {
        lower: 0.0,
        upper: 24.0,
    });
    let offsetTime = ut;
    const actualHours = floor(offsetTime % 24.0);
    offsetTime -= actualHours;
    offsetTime *= 60.0;
    const actualMinutes = floor(offsetTime % 60.0);
    offsetTime -= actualMinutes;
    offsetTime *= 60.0;
    const actualSeconds = floor(offsetTime % 60.0);
    log_1.Log.debug(`[IndexUtils/Schedules] utc hours/minutes/seconds: ${actualHours}:${actualMinutes}:${actualSeconds}`);
    const time = new Date(date.getTime());
    time.setUTCHours(actualHours);
    time.setUTCMinutes(actualMinutes);
    time.setUTCSeconds(actualSeconds);
    return time;
};
exports.calculateSunsetSunriseTime = calculateSunsetSunriseTime;
const createScheduleFromAPI = (sched, device) => {
    const base = {
        id: sched.id,
        scheduledDays: (0, exports.convertIndexDaysToOcelotDays)(sched),
        target: sched.start.update.target,
    };
    const start = constructScheduleFrame(sched, "start", device);
    if (start === undefined) {
        throw new Error("Can't have an undefined start frame");
    }
    return Object.assign({ start, end: constructScheduleFrame(sched, "end", device) }, base);
};
exports.createScheduleFromAPI = createScheduleFromAPI;
const mapSchedules = (schedules, actuators, devices) => {
    const schedule = [];
    for (const sched of Object.values(schedules)) {
        const { deviceId } = actuators[sched.start.update.target];
        let device = devices[deviceId];
        if ((0, TypeUtils_1.isIndexAPIDeviceLoad)(device)) {
            device = devices[device.model.primaryDeviceId];
        }
        schedule.push((0, exports.createScheduleFromAPI)(sched, device));
    }
    return schedule;
};
exports.mapSchedules = mapSchedules;
const DST_OFFSET_M = 60;
const getDSTOffsetM = (today, targetDate, timezone) => {
    const mt = (0, moment_timezone_1.default)(today).tz(timezone);
    const mtd = (0, moment_timezone_1.default)(targetDate).tz(timezone);
    if (mt.isDST() && !mtd.isDST()) {
        return -DST_OFFSET_M;
    }
    if (!mt.isDST() && mtd.isDST()) {
        return DST_OFFSET_M;
    }
    return 0;
};
exports.getDSTOffsetM = getDSTOffsetM;
const getNextSunsetSunriseTimeUTC = (input) => {
    let time = (0, exports.calculateSunsetSunriseTime)(input);
    if (time && time < input.date) {
        const updatedDate = new Date(input.date.getTime());
        updatedDate.setUTCDate(input.date.getUTCDate() + 1);
        time = (0, exports.calculateSunsetSunriseTime)(Object.assign(Object.assign({}, input), { date: updatedDate }));
    }
    return time;
};
exports.getNextSunsetSunriseTimeLocal = lodash_1.default.memoize((input) => {
    log_1.Log.debug(`[IndexUtils/Schedules] calculating ${input.type} at ${JSON.stringify(input.location)} for ${input.date.toISOString()}`);
    const time = getNextSunsetSunriseTimeUTC(Object.assign({}, input));
    if (time === undefined) {
        log_1.Log.debug("[IndexUtils/Schedules] no sunset/sunrise time in near future");
        return undefined;
    }
    const dstOffset = time && (0, exports.getDSTOffsetM)(input.date, time, input.timezone);
    if (dstOffset !== undefined && time !== undefined) {
        log_1.Log.debug(`[IndexUtils/Schedules] detected dst offset: ${dstOffset}`);
        time.setUTCMinutes(time.getUTCMinutes() + dstOffset);
    }
    time.setUTCMinutes(time.getUTCMinutes() + input.timeZoneOffsetM);
    log_1.Log.debug(`[IndexUtils/Schedules] adjusted for timezone offset: ${input.timeZoneOffsetM}`);
    return {
        hours: time.getUTCHours(),
        minutes: time.getUTCMinutes(),
        seconds: time.getUTCSeconds(),
    };
}, ({ date, type, location, timeZoneOffsetM, }) => {
    const { day, month, year } = UTCDate(date);
    const utcHours = date.getUTCHours();
    const utcMinutes = date.getUTCMinutes();
    return `${day}${month}${year}${utcHours}${utcMinutes}${type}${JSON.stringify(location)}${timeZoneOffsetM}`;
});
//# sourceMappingURL=Schedules.js.map